var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPercentage = function SvgPercentage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.5547 5.16794c.4595.30635.5837.92723.2774 1.38673l-8.00004 12.00003c-.30636.4595-.92724.5837-1.38675.2773-.45953-.3063-.58371-.9272-.27737-1.3867l7.99996-12.00002c.3064-.45953.9273-.58369 1.3868-.27734zm-.5547 13.83206c1.6569 0 3-1.3432 3-3 0-1.6569-1.3431-3-3-3s-3 1.3431-3 3c0 1.6568 1.3431 3 3 3zm0-1.7143c.7101 0 1.2857-.5756 1.2857-1.2857s-.5756-1.2857-1.2857-1.2857-1.2857.5756-1.2857 1.2857.5756 1.2857 1.2857 1.2857zm-5-9.28572c0 1.65686-1.34314 3.00002-3 3.00002s-3-1.34316-3-3.00002 1.34314-3 3-3 3 1.34314 3 3zm-1.71429 0c0 .71009-.57563 1.28571-1.28571 1.28571s-1.28571-.57562-1.28571-1.28571c0-.71008.57563-1.2857 1.28571-1.2857s1.28571.57562 1.28571 1.2857z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPercentage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/percentage.9b457337.svg";
export { ForwardRef as ReactComponent };